import { gql } from '@apollo/client';

import { ExerciseMediaItem, CreateExerciseMediaItemInput } from '../../types';
import { exerciseMediaItemFragment } from '../fragments';

export interface CreateExerciseMediaMutationVariables {
  courseId: string;
  subjectId: string;
  input: CreateExerciseMediaItemInput;
}

export interface CreateExerciseMediaMutationResult {
  exerciseMediaItem: ExerciseMediaItem;
}

export const createExerciseMediaMutation = gql`
  mutation CreateExerciseMediaMutation($courseId: String!, $subjectId: String!, $input: CreateExerciseMediaMutationInput!) {
    exerciseMediaItem(courseId: $courseId, subjectId: $subjectId, input: $input)
      @rest(type: "ExerciseMediaItem", path: "courses/{args.courseId}/subjects/{args.subjectId}/media", method: "POST") {
      ...ExerciseMediaItem
    }
  }
  ${exerciseMediaItemFragment}
`;
